import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useMobileWidth } from '../hooks';
import { useFetchJoinTiles } from '../hooks/useFetchNavigationItems';
import { JoinLinks } from '../models';
import { useConfigurationContext } from './ConfigurationContext';
import { jsx as _jsx } from "react/jsx-runtime";
export var NavigationContext = /*#__PURE__*/createContext(undefined);
NavigationContext.displayName = 'NavigationContext';
export var NavigationContextProvider = function NavigationContextProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeLink = _useState2[0],
      setActiveLink = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      iDontKnowYetLink = _useState4[0],
      setIDontKnowYetLink = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      joinTiles = _useState6[0],
      setJoinTiles = _useState6[1];

  var isMobile = useMobileWidth();

  var _useConfigurationCont = useConfigurationContext(),
      tenant = _useConfigurationCont.tenant,
      staticApiUrl = _useConfigurationCont.staticApiUrl;

  var fetchJoinTiles = useFetchJoinTiles();
  var updateActiveLinkAction = useCallback(function (link) {
    if (isMobile && activeLink === link) {
      setActiveLink(null);
    } else {
      setActiveLink(link);
    }
  }, [activeLink, isMobile]);
  useEffect(function () {
    fetchJoinTiles().then(function (response) {
      setJoinTiles(response.filter(function (tile) {
        return tile.linkType === JoinLinks.JoinTile;
      }));
      setIDontKnowYetLink(response.find(function (link) {
        return link.linkType === JoinLinks.IDontKnowYetLink;
      }));
    });
  }, [fetchJoinTiles, staticApiUrl, tenant]);
  var value = useMemo(function () {
    return {
      activeLink: activeLink,
      iDontKnowYetLink: iDontKnowYetLink,
      joinTiles: joinTiles,
      updateActiveLinkAction: updateActiveLinkAction
    };
  }, [activeLink, iDontKnowYetLink, joinTiles, updateActiveLinkAction]);
  return /*#__PURE__*/_jsx(NavigationContext.Provider, {
    value: value,
    children: children
  });
};
export var useNavigationContext = function useNavigationContext() {
  var context = useContext(NavigationContext);

  if (context) {
    return context;
  }

  throw new Error('NavigationContext value must be set.');
};